export const exit = async () => {
  console.log("Goodbye!");
  process.exit(0);
};
